export default {
    "alwaysChallenge": true,
    "resultType": "SUCCESS",
    "allowAuthenticator": true,
    "voiceMfaAllowed": true,
    "voiceMfaSetupAllowed": true,
    "mfaChoice": true
}

